import React from 'react';
import FormDateRangepickerContain from '../../../Componant/Forms/FormWidget/FormDateRangePicker';

const DateRangePicker = () => {
  return (
    <div className='page-body'>
      <FormDateRangepickerContain />
    </div>
  );
};

export default DateRangePicker;
